export default __webpack_public_path__ + "static/media/cvv_logo.515cfd08.svg";